import styled, { theme } from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'

import { Heading1 } from '../typography'

export const H1 = styled(Heading1)`
  margin-top: ${rem(15)};
  margin-bottom: ${rem(15)};
  margin-right: auto;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const Value = styled.strong`
  margin: 0;
  font-weight: 500;
  font-size: ${rem(15)};
  line-height: ${rem(22)};
`
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const Link = styled.a`
  color: ${theme('typography.link.color')};
  font-size: ${rem(15)};
  font-weight: ${(p) => p.theme.typography.link.fontWeight};
  line-height: ${rem(28)};
`
export const MobileLink = styled(Link)`
  ${(p) => p.theme.media.min.md`
    display: none;
  `}
`
export const Span = styled.span`
  display: none;
  font-size: ${rem(15)};
  font-weight: ${(p) => p.theme.typography.paragraph.fontWeight};
  line-height: ${rem(28)};
  ${(p) => p.theme.media.min.md`
    display: inline;
  `}
`

export const Text = styled.strong`
  font-size: ${rem(15)};
  font-weight: ${(p) => p.theme.typography.paragraph.fontWeight};
  line-height: ${rem(22)};
`
